export enum FolderAction {
	REMOVE = 0,
	CREATE = 1,
	UPDATE = 2,
	MOVE = 3
}
